/**
 * Created by Jerker Nord on 2021-01-27.
 */
import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { AssetsConfig } from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { FontLoader } from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import { OpenSans } from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

import { setAssetsLoader } from "../../abstracts/graphics/AbstractSpine";
import { DDD } from "../DDD";
import { DDDFontsNames, DDDSpineNames, DDDWaysTTF, DDDWildTTF } from "./DDDAssetsNames";

export class DDDAssetsLoader {
    private static getSpineAssets(): SpineAsset[] {
        const spineAssets: SpineAsset[] = Object.values(DDDSpineNames).map(
            (name) => new SpineAsset(name, name)
        );

        return spineAssets;
    }

    public static loadTTF(): Promise<[boolean, any]> {
        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);
        fontLoader.add(DDDWaysTTF.NORMAL);
        fontLoader.add(DDDWildTTF.NORMAL);

        AssetsConfig.addToAssetsConfig(DDDAssetsLoader.RESOURCES_GROUPS);
        DDD.assetLoader = new AssetLoader(
            DDD.apiPlugin,
            NolimitApplication.resourcePath + `/resources/`
        );
        setAssetsLoader(DDD.assetLoader);

        return Promise.all([fontLoader.load(), DDD.assetLoader.load(ResourcesGroupName.MAIN)]);
    }

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: `fonts`,
                assets: [
                    new BitmapFontAsset(
                        DDDFontsNames.DEFAULT,
                        `fonts/bitmapfonts/DDDDefaultFont.fnt`
                    ),
                ],
            },
            {
                name: `backgrounds`,
                // autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`backgrounds0`, `sheets/backgrounds/backgrounds0.json`),
                    new TextureAsset(`backgrounds1`, `sheets/backgrounds/backgrounds1.json`),
                    new TextureAsset(`backgrounds2`, `sheets/backgrounds/backgrounds2.json`),
                    new TextureAsset(`backgrounds3`, `sheets/backgrounds/backgrounds3.json`),
                ],
            },
            {
                name: `bigwins`,
                assets: [
                    new TextureAsset(`bigWin0`, `sheets/bigwins/bigwins0.json`),
                    new TextureAsset(`bigWin1`, `sheets/bigwins/bigwins1.json`),
                    new TextureAsset(`bigWin2`, `sheets/bigwins/bigwins2.json`),
                    new TextureAsset(`bigWin3`, `sheets/bigwins/bigwins3.json`),
                    new TextureAsset(`bigWin4`, `sheets/bigwins/bigwins4.json`),
                    new TextureAsset(`bigWin5`, `sheets/bigwins/bigwins5.json`),
                    new TextureAsset(`bigWin6`, `sheets/bigwins/bigwins6.json`),
                ],
            },
            {
                name: `freespins`,
                assets: [
                    new TextureAsset(`freespins0`, `sheets/introOutro/introOutro0.json`),
                    new TextureAsset(`freespins1`, `sheets/introOutro/introOutro1.json`),
                    new TextureAsset(`freespins2`, `sheets/introOutro/introOutro2.json`),
                    new TextureAsset(`freespins3`, `sheets/introOutro/introOutro3.json`),
                    // new TextureAsset(`freespins1`, `sheets/introOutro/introOutro1.json`),
                ],
                animations: {},
            },
            {
                name: `main`,
                assets: [
                    new TextureAsset(`main0`, `sheets/main/main0.json`),
                    // new TextureAsset(`main1`, `sheets/main/main1.json`),
                    // new TextureAsset(`main2`, `sheets/main/main2.json`),
                    // new TextureAsset(`main3`, `sheets/main/main3.json`),
                    // new TextureAsset(`main4`, `sheets/main/main4.json`),
                    // new TextureAsset(`main5`, `sheets/main/main5.json`),
                ],
            },
            {
                name: `mainJpeg`,
                assets: [
                    new TextureAsset(`mainJpeg0`, `sheets/mainJpeg/mainJpeg0.json`),
                    new TextureAsset(`mainJpeg1`, `sheets/mainJpeg/mainJpeg1.json`),
                    new TextureAsset(`mainJpeg2`, `sheets/mainJpeg/mainJpeg2.json`),
                    new TextureAsset(`mainJpeg3`, `sheets/mainJpeg/mainJpeg3.json`),
                    new TextureAsset(`mainJpeg4`, `sheets/mainJpeg/mainJpeg4.json`),
                ],
            },
            {
                name: `reels`,
                assets: [
                    new TextureAsset(`reels0`, `sheets/reels/reels0.json`),
                    // new TextureAsset(`reels1`, `sheets/reels/reels1.json`),
                ],
                animations: {},
            },
            {
                name: `symbols`,
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`symbols0`, `sheets/symbols/symbols0.json`),
                    new TextureAsset(`symbols1`, `sheets/symbols/symbols1.json`),
                    new TextureAsset(`symbols2`, `sheets/symbols/symbols2.json`),
                    // new TextureAsset(`symbols4`, `sheets/symbols/symbols4.json`),
                ],
                animations: {},
            },
            {
                name: `spine`,
                assets: this.getSpineAssets(),
            },
        ],
    };
}
